import { MAX_WAREHOUSES } from '../constants/inventoryWarehouse'

export const buildWarehouseCode = value => `BOD-${String(value).padStart(2, '0')}`

export const getWarehouseCodeNumber = value => {
  const match = String(value || '')
    .trim()
    .toUpperCase()
    .match(/^BOD-(\d{2})$/)

  if (!match) return null

  const numeric = Number(match[1])
  if (!Number.isInteger(numeric) || numeric < 1 || numeric > MAX_WAREHOUSES) return null
  return numeric
}

export const getNextWarehouseCode = rows => {
  const usedCodes = new Set(
    rows
      .map(row => getWarehouseCodeNumber(row?.code ?? row?.codigo))
      .filter(value => Number.isInteger(value))
  )

  for (let index = 1; index <= MAX_WAREHOUSES; index += 1) {
    if (!usedCodes.has(index)) return buildWarehouseCode(index)
  }

  return null
}
